

















import Component, { mixins } from "vue-class-component";
import { Rapport } from "@/shared/Rapport";
import MobileRapportConfig from "@/components/mobileRapportConfig.vue";
import RapportConfig from "@/components/rapportConfig.vue";
import MobileMixin from "@/mixins/mobileMixin";

@Component({
  components: { MobileRapportConfig, RapportConfig },
})
export default class Rapports extends mixins(MobileMixin) {
  public updateRapport(rapport: Rapport) {
    this.$store.dispatch("rapport/updateRapport", rapport);
  }

  get rapport(): Rapport {
    return this.$store.getters["rapport/rapport"];
  }
}
